<template>
  <div class="right_side">
    <About/>
    <Expiriences/>
    <Projects/>
    <PersonalAbout/>
  </div>
</template>

<script>
import About from './About.vue';
import Expiriences from './Expiriences.vue';
import Projects from './PersonalProject.vue';

export default {
  name: 'RightSize',
  components: {
    About,
    Expiriences,
    Projects,
  }
}
</script>

<style scoped>
.right_side
{
  position: relative;
  background: #FFFFFF;
  padding: 40px;
  min-width: 40rem;
  box-shadow: 2px 10px 6px -4px black;
}
</style>
